import { useMutation } from '@tanstack/react-query'

import { useMe } from '@shared/providers/src/MeProvider'
import { queryClient } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function useGiveConsent() {
  const me = useMe()

  return useMutation({
    mutationFn: (data) => API.patients.id(me.id).consents.agree(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QK.patients.id(me.id).consents.lists }),
  })
}
